import { useEffect } from 'react';
import * as uuid from 'uuid';

const events = ['mousedown', 'mousemove', 'keypress', 'scroll', 'touchstart'];

const useIdleHook = ({
    timeout,
    onIdle,
}: {
    timeout: number;
    onIdle: () => void;
}): void => {
    let idleIntervalCheck: any;

    const manageWindowReference = (
        reference: string,
        action: 'add' | 'remove'
    ): void => {
        let windowReferences: any = localStorage.getItem('windowReferences');
        if (windowReferences) {
            windowReferences = JSON.parse(windowReferences);
        } else {
            windowReferences = [];
        }
        if (action === 'add') {
            windowReferences.push(reference);
        } else {
            // eslint-disable-next-line no-debugger
            // debugger;
            const index = windowReferences.findIndex(
                (r: string) => r === reference
            );
            console.log(windowReferences, index);
            if (index > -1) {
                windowReferences.splice(index);
            }
            console.log(windowReferences, index);
            if (
                windowReferences &&
                Array.isArray(windowReferences) &&
                windowReferences.some((t) => t === window.windowReference) ===
                    false
            ) {
                window.windowReference = undefined;
            }
            if (windowReferences.length > 0) {
                localStorage.setItem(
                    'activeWindow',
                    windowReferences[windowReferences.length - 1]
                );
            }
        }
        localStorage.setItem(
            'windowReferences',
            JSON.stringify(windowReferences)
        );
    };
    const windowReference = (): string => {
        const w: any = window;
        if (w.windowReference) {
            return w.windowReference;
        }
        const reference = uuid.v4();
        w.windowReference = reference;
        manageWindowReference(reference, 'add');
        return reference;
    };

    const onUserPreviousAction = (): void => {
        const previousWindow = localStorage.getItem('activeWindow');
        const windowReferences: any = localStorage.getItem('windowReferences');
        const windowReferencesParsed = JSON.parse(windowReferences);

        if (
            typeof previousWindow === 'string' &&
            windowReferencesParsed &&
            Array.isArray(windowReferencesParsed) &&
            windowReferencesParsed.some((c: any) => c === previousWindow) ===
                false &&
            typeof window.windowReference === 'undefined'
        ) {
            const sIdleAfter = localStorage.getItem('idleAfter');
            if (Number(sIdleAfter) <= Date.now()) {
                console.log(
                    'Calling timeout from previously',
                    window.windowReference
                );
                onIdle();
            }
        }
    };

    const onUserAction = (): void => {
        clearInterval(idleIntervalCheck);
        localStorage.setItem('activeWindow', windowReference());
        const idleAfter = Date.now() + timeout;
        localStorage.setItem('idleAfter', `${idleAfter}`);
        idleIntervalCheck = setInterval(() => {
            const reference = localStorage.getItem('activeWindow');
            const sIdleAfter = localStorage.getItem('idleAfter');
            const w: any = window;
            console.log('Timout After', Number(sIdleAfter) - Date.now());
            console.log('Timeout from window', w.windowReference);
            console.log('Active window', reference);
            if (
                reference === w.windowReference &&
                Number(sIdleAfter) <= Date.now()
            ) {
                console.log('Calling timeout from', w.windowReference);
                localStorage.removeItem('idleAfter');
                onIdle();
            }
        }, 5000);
    };

    const removeListeners = (): void => {
        events.forEach((name) => {
            document.removeEventListener(name, onUserAction, true);
        });
    };
    const stopIdleCheck = (): void => {
        removeListeners();
        const w: any = window;
        manageWindowReference(w.windowReference, 'remove');
        clearInterval(idleIntervalCheck);
    };

    const startIdleCheck = (): void => {
        removeListeners();
        onUserPreviousAction();
        events.forEach((name) => {
            document.addEventListener(name, onUserAction, true);
        });
        onUserAction();
    };

    useEffect(() => {
        console.log('Initializing idle check');
        startIdleCheck();
        window.addEventListener('unload', stopIdleCheck);
        return () => {
            console.log('Stoping idle check');
            window.removeEventListener('unload', stopIdleCheck, true);
            stopIdleCheck();
        };
    }, []);
};

export default useIdleHook;
